/**
 * 저장 버튼의 진행 표시·라벨 판정.
 *
 * IXD 편집 세션을 쓰는 세 화면(ixd-editor / ixd-dsd-compare / ixd-workbook-match)이
 * 같은 판정을 각자 인라인으로 들고 있었다. Button API가 화면마다 달라(children vs
 * leftIcon, 아이콘 크기 상이) 컴포넌트로 묶으면 래퍼가 원래 마크업보다 커지므로,
 * 마크업은 각 화면에 남기고 **판정만** 여기로 모은다.
 *
 * 저장은 두 구간이다 — PATCH 요청(saveInFlight)과 그 뒤 백그라운드 재조회(isReflecting).
 * 둘 다 진행 중이지만 사용자에게 다른 일이 벌어지고 있음을 라벨로 구분한다.
 */

export interface SaveButtonState {
  /** 스피너를 띄울 구간 — PATCH 요청 중이거나 백그라운드 재조회 중 */
  inProgress: boolean;
  label: "저장" | "반영 중";
}

export const getSaveButtonState = (
  saveInFlight: boolean,
  isReflecting: boolean,
): SaveButtonState => ({
  inProgress: saveInFlight || isReflecting,
  label: isReflecting ? "반영 중" : "저장",
});
